import { StatisticsListColumnProperties } from '@/models/statistics/statistics-list-column-properties.model';

export const STATISTICS_LIST_COLUMN_LABELS = {
  [StatisticsListColumnProperties.SECTION]: 'Section',
  [StatisticsListColumnProperties.REGISTRATION_COUNT]: 'Regs',
  [StatisticsListColumnProperties.FIRST_DEPOSIT_COUNT]: 'FTD',
  [StatisticsListColumnProperties.ACTIVE_PLAYER_COUNT]: 'Active players',
  [StatisticsListColumnProperties.DEPOSIT_SUM]: 'Deposit sum',
  [StatisticsListColumnProperties.CASHOUT_SUM]: 'Cash out sum',
  [StatisticsListColumnProperties.BET_SUM]: 'Total bets',
  [StatisticsListColumnProperties.WIN_SUM]: 'Total wins',
  [StatisticsListColumnProperties.GGR]: 'GGR',
  [StatisticsListColumnProperties.NGR]: 'NGR',
  [StatisticsListColumnProperties.RTP]: 'RTP',
};
